import React, { useState, useEffect } from 'react';
import './installPrompt.css';

const InstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPrompt, setShowPrompt] = useState(false);

    useEffect(() => {
        const handler = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        
        // Check if user has already dismissed the prompt
        const hasSeenPrompt = localStorage.getItem('hasSeenInstallPrompt');
        if (!hasSeenPrompt) {
            setShowPrompt(true);
        }
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    useEffect(() => {
        const handler = (e) => {
            // console.log('beforeinstallprompt event fired!');
            e.preventDefault();
            setDeferredPrompt(e);
            
            const hasSeenPrompt = localStorage.getItem('hasSeenInstallPrompt');
            // console.log('Has seen prompt:', hasSeenPrompt);
            if (!hasSeenPrompt) {
            setShowPrompt(true);
        }
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        
        console.log(`User response: ${outcome}`);
        setDeferredPrompt(null);
        setShowPrompt(false);
        //localStorage.setItem('hasSeenInstallPrompt', 'true');
    };

    const handleDismiss = () => {
        setShowPrompt(false);
        localStorage.setItem('hasSeenInstallPrompt', 'true');
    };

    if (!showPrompt) return null;

    return (
        <div className="install-prompt-overlay">
            <div className="install-prompt-box">
                <h3>Install Prof_iX App</h3>
                <p>Add Prof_iX App to your home screen for quick and easy access!</p>
                <div className="install-prompt-buttons">
                <button onClick={handleInstall} className="install-button">
                    Install
                </button>
                <button onClick={handleDismiss} className="dismiss-button">
                    Maybe Later
                </button>
                </div>
            </div>
        </div>
    );
};

export default InstallPrompt;